import bp from 'shared/constants/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ModalWrapper = styled.div(
  (props: { collapsed: boolean }) => css`
    display: ${props.collapsed ? 'none' : 'initial'};
  `
)

export const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 1em;
`

export const BottomWrapper = styled.div`
  display: flex;
  gap: 1em;
  justify-content: space-between;

  @media screen and (max-width: ${bp.medium}) {
    flex-direction: column;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  gap: 1em;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: 0.5em;

  button {
    min-width: 100px;
  }
`

export const ScrollWrapper = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  margin-right: -2em;
  padding-right: 2em;
  display: grid;
  grid-row-gap: 1em;
`
